<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <div
      id="g-recaptcha"
      class="g-recaptcha"
      :data-sitekey="sitekey">
  </div>
</template>

<script>
export default {
  name: "GoogleRecaptcha",
  data() {
    return {
      sitekey: '6LfixOEUAAAAAIOTxsIALcXycK8V5445tG4pfl0n',
      recaptachId: 0
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    execute() {
      window.grecaptcha.execute(this.recaptachId)
    },
    reset() {
      window.grecaptcha.reset(this.recaptachId)
    },
    render() {
      if (window.grecaptcha) {
        this.recaptachId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',
          callback: (results) => {
            this.$emit('verify', results)
            this.reset()
          }
        })
      }
    }
  }
}
</script>